// extracted by mini-css-extract-plugin
export default {"title":"AccountsPayableDetails_title__gIclm","pay":"AccountsPayableDetails_pay__hCMeo"};